import { Routes } from "@angular/router";
import { StockNotificationSettingsRoutePaths } from "./stock-notification-settings-route-path";
import { stockNotificationSettingsResolver } from "./resolvers/stock-notification-settings.resolver";
import { COMMON_GUARD_OPTIONS } from "@app/shared/auth/constants/permissions.constant";
import { IAuthGuardOptions } from "@app/shared/auth/interfaces/auth.interface";
import { AuthGuard } from "@app/shared/auth/guards/auth.guard";
import { NotificationSettingsRoutePaths } from "@app/applications/settings/domains/notification-settings/notification-settings-route-path";

const authGuardOptions: IAuthGuardOptions = {
  permissions: [
    ...COMMON_GUARD_OPTIONS.STOCK_NOTIFICATION_SETTINGS.GET.permissions,
    ...COMMON_GUARD_OPTIONS.STOCK_NOTIFICATION_SETTINGS.SET.permissions,
  ],
  redirectTo: `/${NotificationSettingsRoutePaths.BASE_URL}`,
};

export const stockNotificationSettingsRoutes: Routes = [
  {
    path: StockNotificationSettingsRoutePaths.ROOT,
    loadComponent: () =>
      import("./pages/stock-notification-settings/stock-notification-settings.component").then(t => t.StockNotificationSettingsComponent),
    resolve: {
      stockNotificationSettings: stockNotificationSettingsResolver,
    },
    canActivate: [AuthGuard],
    data: { authGuardOptions },
  },
];
